import React from "react";

/**
 * Lightweight hover tooltip. Wraps any element and shows `label` on hover.
 *
 * Uses a named Tailwind group (`group/tt`) so nested/sibling tooltips don't
 * interfere with each other. Renders above the wrapped element by default.
 */
const Tooltip = ({ label, children, className = "", position = "top" }) => {
  if (!label) return children;

  const positionClasses =
    position === "bottom"
      ? "top-full mt-2"
      : "bottom-full mb-2";

  const arrowClasses =
    position === "bottom"
      ? "bottom-full left-1/2 -translate-x-1/2 border-b-gray-900"
      : "top-full left-1/2 -translate-x-1/2 border-t-gray-900";

  return (
    <div className={`relative group/tt ${className}`}>
      {children}
      <div
        role="tooltip"
        className={`pointer-events-none absolute left-1/2 z-50 w-56 -translate-x-1/2 rounded-lg bg-gray-900 px-3 py-2 text-caption font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover/tt:opacity-100 ${positionClasses}`}
      >
        {label}
        <span
          className={`absolute border-4 border-transparent ${arrowClasses}`}
        />
      </div>
    </div>
  );
};

export default Tooltip;
